import { render, staticRenderFns } from "./OccurrenceType.vue?vue&type=template&id=3e42e9dc"
import script from "./OccurrenceType.vue?vue&type=script&lang=js"
export * from "./OccurrenceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports